<template>
  <div class="wrap firmorder-wrap flex-column">
    <mu-infinite-scroll
      :loading="pay.loading"
      :loadingText="pay.message"
      class="load maskloading"
      v-show="pay.loading"
    />
    <mu-infinite-scroll
      :loading="load"
      loadingText="拼命加载中"
      class="load"
      v-show="load"
    />
    <div class="flex-item firmorderWrapper" v-show="!load">
      <div class="firmorder-content">
        <div class="order-box addr" v-if="addressInfo.length > 0">
          <div class="border-img top"></div>
          <div class="addr-info" @click="openaddr">
            <p class="addr-title">收货人信息</p>
            <p>
              收货人：{{
                addressInfo &&
                addressInfo[selectAddressIndex] &&
                addressInfo[selectAddressIndex].consignee
              }}
              <label class="fr">{{
                addressInfo &&
                addressInfo[selectAddressIndex] &&
                addressInfo[selectAddressIndex].mobile
              }}</label>
            </p>
            <p>
              收货地址：{{
                addressInfo &&
                addressInfo[selectAddressIndex] &&
                addressInfo[selectAddressIndex].province
              }}
              {{
                addressInfo &&
                addressInfo[selectAddressIndex] &&
                addressInfo[selectAddressIndex].city
              }}
              {{
                addressInfo &&
                addressInfo[selectAddressIndex] &&
                addressInfo[selectAddressIndex].area
              }}
              {{
                addressInfo &&
                addressInfo[selectAddressIndex] &&
                addressInfo[selectAddressIndex].address
              }}
            </p>
          </div>
          <div class="border-img bottom"></div>
        </div>
        <div class="order-box addr" v-else>
          <div class="border-img top"></div>
          <div class="none-addr-info">
            <p>您还没有收货地址，赶快添加吧！</p>
            <mu-raised-button
              label="+ 新建地址"
              class="demo-raised-button"
              @click="addaddr"
            />
          </div>
          <div class="border-img bottom"></div>
        </div>
        <template
          v-for="(storeItem, storeIndex) in OrderSettleMsg.storeOrderSettleMsgs"
        >
          <div class="order-box">
            <div class="brandTitle">
              <span @click="gotoBrandHome(storeItem.settleGoodsMsg.storeId)">
                <imgs
                  :width="120"
                  :imagePath="
                    storeItem &&
                    storeItem.settleGoodsMsg &&
                    storeItem.settleGoodsMsg.storeLogoPath &&
                    storeItem.settleGoodsMsg.storeLogoPath.imagePath
                  "
                  class="logo floatL"
                ></imgs>
                <!-- <img class="logo floatL" src="/static/images/mexin_logo_3x.png"> -->
                <p>
                  <label>品牌：{{ storeItem.settleGoodsMsg.storeName }}</label>
                </p>
                <img class="user-right" src="/static/images/ic_more_3x.png" />
              </span>
              <input
                v-model="settleDatas[storeIndex].dealerCode"
                placeholder="经销商编码"
              />
              <div class="clearfix"></div>
            </div>
            <mu-list>
              <myOrdersItem
                v-for="(goodItem, goodIndex) in storeItem.settleGoodsMsg
                  .cartGoodses"
                :cartitem="goodItem"
                :key="goodIndex"
              >
              </myOrdersItem>
            </mu-list>
          </div>
          <div class="order-box">
            <p
              class="order-box-item"
              @click="
                couponPopup = true;
                currentCoupon = storeIndex;
              "
              v-if="storeItem.couponMsgs.length > 0"
            >
              优惠券：
              <label class="fr black">
                <template v-if="settleDatas[storeIndex].couponInstId == 0"
                  >不使用优惠券</template
                >

                <template
                  v-if="
                    settleDatas[storeIndex].couponInstId != 0 &&
                    couponAmounts[storeIndex].couponCate == 3
                  "
                  >{{
                    couponAmounts[storeIndex].couponDiscount | discount
                  }}折优惠券</template
                >
                <template
                  v-if="
                    settleDatas[storeIndex].couponInstId != 0 &&
                    couponAmounts[storeIndex].couponCate != 3
                  "
                  >{{ couponAmounts[storeIndex] }}元优惠券</template
                >
                <img class="user-right" src="/static/images/ic_more_3x.png" />
              </label>
            </p>
            <p class="order-box-item" v-else>
              优惠券：
              <label class="fr not-available">无可用</label>
            </p>
            <p
              class="order-box-item"
              @click="
                redpackagePopup = true;
                currentCoupon = storeIndex;
              "
              v-if="storeItem.redpacketMsgs.length > 0"
            >
              红包：
              <label class="fr black">
                <template v-if="settleDatas[storeIndex].redpacketInstId == 0"
                  >不使用红包</template
                >
                <template v-if="settleDatas[storeIndex].redpacketInstId != 0"
                  >{{ redpacketAmounts[storeIndex] }}元红包</template
                >
                <img class="user-right" src="/static/images/ic_more_3x.png" />
              </label>
            </p>
            <p class="order-box-item" v-else>
              红包：<label class="fr not-available">无可用</label>
            </p>
          </div>
          <div class="order-box">
            <input
              class="order-box-item"
              v-model="settleDatas[storeIndex].remark"
              placeholder="选填：给商家留言 （50字以内）"
            />
          </div>
          <div class="order-box mgb">
            <p class="order-box-item">
              &nbsp;
              <label class="fr"
                >合计：<span class="primary"
                  >￥{{ storeItem.finalPrice }}</span
                ></label
              >
            </p>
          </div>
        </template>
        <div class="order-box mgb">
          <!-- <div class="clearfix"></div> -->
          <p class="order-box-item" @click="openinvoice">
            发票信息：
            <label class="fr black"
              >{{ invoinceInfo
              }}<img class="user-right" src="/static/images/ic_more_3x.png"
            /></label>
          </p>
        </div>
        <div class="order-box mgb">
          <p class="order-box-item">
            商品金额：
            <label class="fr primary"
              >￥{{ OrderSettleMsg.totalGoodsPrice }}</label
            >
          </p>
          <p class="order-box-item">
            运费：
            <label class="fr primary">+￥{{ OrderSettleMsg.postPrice }}</label>
          </p>
          <p class="order-box-item">
            优惠券：
            <label class="fr primary"
              >-￥{{ OrderSettleMsg.discountPrice }}</label
            >
          </p>
          <p class="order-box-item textright">
            实付款：
            <label class="fr primary">￥{{ OrderSettleMsg.finalPrice }}</label>
          </p>
        </div>
      </div>
      <div class="fullbtn-box">
        <mu-raised-button
          label="创建订单"
          fullWidth
          @click="onCreatOrder"
          class="full"
        />
        <!-- <mu-raised-button label="银联支付" fullWidth @click="submitUnionOrder" class="full Union"/> -->
      </div>
      <!-- <div class="fullbtn-box">
        <mu-raised-button label="微信支付" fullWidth @click="submitOrder" class="full wx"/>
        <mu-raised-button label="银联支付" fullWidth @click="submitUnionOrder" class="full Union"/>
      </div> -->
    </div>
    <!-- 当前没有地址时不显示 -->
    <p
      class="delivery-addr"
      v-if="scrolled > 200 && addressInfo.length > 0 && !load"
    >
      配送至：{{
        addressInfo &&
        addressInfo[selectAddressIndex] &&
        addressInfo[selectAddressIndex].province
      }}
      {{
        addressInfo &&
        addressInfo[selectAddressIndex] &&
        addressInfo[selectAddressIndex].city
      }}
      {{
        addressInfo &&
        addressInfo[selectAddressIndex] &&
        addressInfo[selectAddressIndex].area
      }}
      {{
        addressInfo &&
        addressInfo[selectAddressIndex] &&
        addressInfo[selectAddressIndex].address
      }}
      （
      {{
        addressInfo &&
        addressInfo[selectAddressIndex] &&
        addressInfo[selectAddressIndex].consignee
      }}
      {{
        addressInfo &&
        addressInfo[selectAddressIndex] &&
        addressInfo[selectAddressIndex].mobile
      }}
      收）
    </p>
    <!-- <div class="cartBottom" v-if="!load">
      <p class="count ellipsis">实付款：<span>￥{{OrderSettleMsg.finalPrice}}</span><span></span></p>
      <div class="go primarybtn" @click="submitOrder">去付款</div>
    </div> -->
    <!-- 优惠券弹框 -->
    <mu-popup
      position="bottom"
      popupClass="coupon-popup-bottom flex-column"
      :open="couponPopup"
      @close="couponPopup = false"
    >
      <div class="flex-item">
        <div class="goods-detail">
          <div class="close-button" @click="couponPopup = false"></div>
          <div class="coupon-box" v-if="currentCoupon >= 0">
            <div class="coupon-list">
              <div class="coupon-list-item title">
                选择优惠券
              </div>
              <div
                class="coupon-list-item"
                v-for="(couponItem, couponIndex) in OrderSettleMsg
                  .storeOrderSettleMsgs[currentCoupon].couponMsgs"
                @click="selCoupon('1', couponItem.couponInstId)"
              >
                <template v-if="couponItem.couponInstId == 0">
                  {{ couponItem.couponName }}
                </template>
                <template v-if="couponItem.couponInstId != 0">
                  <template v-if="couponItem.couponCate != 3"
                    >省{{ couponItem.couponAmount }}元</template
                  >
                  <template v-if="couponItem.couponCate == 3"
                    >{{ couponItem.couponDiscount | discount
                    }}<samp>折</samp></template
                  >
                  ：满{{ couponItem.useableAmount }}可用，{{
                    couponItem.couponName
                  }}
                </template>
                <mu-radio
                  name="group"
                  :nativeValue="'' + couponItem.couponInstId"
                  v-model="settleDatas[currentCoupon].couponInstId"
                  class="list-radio fr"
                  @change="selCoupon('1', couponItem.couponInstId)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="bottom-button">
                <mu-raised-button label="确定" class="fullButton" primary/>
            </div> -->
    </mu-popup>
    <!-- 红包弹框 -->
    <mu-popup
      position="bottom"
      popupClass="coupon-popup-bottom flex-column"
      :open="redpackagePopup"
      @close="redpackagePopup = false"
    >
      <div class="flex-item">
        <div class="goods-detail">
          <div class="close-button" @click="redpackagePopup = false"></div>
          <div class="coupon-box" v-if="currentCoupon >= 0">
            <div class="coupon-list">
              <div class="coupon-list-item title">
                选择红包
              </div>
              <div
                class="coupon-list-item"
                v-for="(couponItem, couponIndex) in OrderSettleMsg
                  .storeOrderSettleMsgs[currentCoupon].redpacketMsgs"
                @click="selCoupon('2', couponItem.couponInstId)"
              >
                <template v-if="couponItem.couponInstId == 0">
                  {{ couponItem.couponName }}
                </template>
                <template v-if="couponItem.couponInstId != 0">
                  省{{ couponItem.couponAmount }}元：满{{
                    couponItem.useableAmount
                  }}可用，{{ couponItem.couponName }}
                </template>
                <mu-radio
                  name="group"
                  :nativeValue="'' + couponItem.couponInstId"
                  v-model="settleDatas[currentCoupon].redpacketInstId"
                  class="list-radio fr"
                  @change="selCoupon('2', couponItem.couponInstId)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </mu-popup>

    <!-- 微信支付确认 -->
    <mu-dialog
      :open="isShowFirmBox"
      title="请确认微信支付是否已完成"
      titleClass="payTitle dialogTitle"
      bodyClass="dialogBody payBody"
      actionsContainerClass="payActionsContainer"
    >
      <div @click="finishPay">已完成支付</div>
      <div slot="actions" @click="callH5WxPay(createOrderData.orderId)">
        支付遇到问题，重新支付
      </div>
    </mu-dialog>
    <mu-toast
      v-if="toast.isShow"
      :message="toast.messageTip"
      class="custom-toast"
    />
  </div>
</template>
<script type="text/javascript">
import touchDelete from "@components/touchDelete/touchDelete";
import menus from "@components/menus/menus";
import imgs from "@components/image/image";
import myOrdersItem from "@components/myOrdersItem/myOrdersItem";
import { mapActions } from "vuex";
import { storage } from "@common/utils/util.js";
import wx from "weixin-js-sdk";
export default {
  data() {
    return {
      load: true,
      value: [], //选中的id
      allChecked: false, //全选状态
      couponPopup: false, //优惠券弹框
      redpackagePopup: false, //红包弹框
      id: "",
      goodsNumber: 0, //加减框  数量
      isEdit: false, //编辑状态
      scrolled: 0, //监听滚动事件
      addressInfo: [], //地址列表
      selectAddressIndex: 0, //选中的地址  下标
      addInfo: {}, //用户新增的发票抬头
      invoiceTypeList: [], //获取发票类型列表
      invoiceContentList: [], //获取发票内容列表
      memInvoiceMsgList: [], //获取会员单位发票列表
      settleDatas: [], //结算店铺列表
      OrderSettleMsg: {}, //订单信息
      couponAmounts: [], //选中的优惠券
      // 发票信息
      invoiceData: {},
      invoinceInfo: "不开发票", //发票信息
      currentCoupon: -1, //当前选中的优惠券
      orderData: {}, //订单信息（包含店铺结算信息  店铺优惠金额）
      createOrderData: {}, //订单提交结果
      toast: {
        isShow: false,
        messageTip: "",
      },
      pay: {
        loading: false,
        message: "提交订单···",
      },
    };
  },
  watch: {
    //深度 watcher
  },
  computed: {
    isShowFirmBox() {
      return this.$route.query.isShowFirmBox == "1" ? true : false;
    },
  },

  created() {
    //获取地址信息
    this.getListAddress();
    //获取订单数据
    this.getOrderSettle(this.$route.query.ids);
    //获取发票信息
    if (storage.local.get("invoiceData") != null) {
      this.invoiceData = storage.local.get("invoiceData");
      if (
        this.invoiceData.invoiceTypeName &&
        this.invoiceData.invoiceHead &&
        this.invoiceData.invoiceContentName != "不开发票"
      ) {
        this.invoinceInfo =
          this.invoiceData.invoiceTypeName +
          " " +
          this.invoiceData.invoiceHead +
          "  " +
          this.invoiceData.invoiceContentName;
      }
    }
  },
  methods: {
    ...mapActions({
      getOrderSettleMsgFromCart: "getOrderSettleMsgFromCart", //购物车结算
      createOrder: "createOrder", //提交订单
      createOrderWithOrder: "createOrderWithOrder", //15.6.提交订单（带订单号）
      listAddress: "listAddress", //获取地址列表
      getWxJsSdkConfig: "getWxJsSdkConfig", //获取微信js配置config
      doWxMpPay: "doWxMpPay", //微信公众号支付
      doWxH5Pay: "doWxH5Pay", //微信H5支付
      doUnionWapConsumePay: "doUnionWapConsumePay", //银联手机网页支付
    }),

    showTipMessage(isShow, msg) {
      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(() => {
        this.toast.isShow = false;
      }, 1500);
    },

    gotoBrandHome(storeid) {
      this.$router.push({
        path: "/main/brandHome?linkTarget=" + storeid + "&linkType=2",
      });
    },
    getOrderSettle(ids) {
      if (storage.local.get("orderData")) {
        this.orderData = storage.local.get("orderData");
        this.OrderSettleMsg = this.orderData.OrderSettleMsg;
        this.settleDatas = this.orderData.settleDatas;
        this.couponAmounts = this.orderData.couponAmounts;
        this.redpacketAmounts = this.orderData.redpacketAmounts;
        this.load = false;
      } else {
        location.href = "/main/cart";
      }
    },

    //选择优惠券  type  1 优惠券  2  红包    instId位当前选中的优惠券InstId
    selCoupon(type, instId) {
      let _this = this;
      let index = this.currentCoupon;
      if (type == "1") {
        this.settleDatas[this.currentCoupon].couponInstId = instId;
        this.OrderSettleMsg.storeOrderSettleMsgs[index].couponMsgs.forEach(
          function (item) {
            if (item.couponInstId == instId) {
              if (item.couponCate == 3) {
                _this.couponAmounts[index] = item;
              } else {
                _this.couponAmounts[index] = item.couponAmount; //改变后优惠券金额
              }
            }
          }
        );
        this.couponPopup = false;
      } else if (type == "2") {
        this.settleDatas[index].redpacketInstId = instId;
        this.OrderSettleMsg.storeOrderSettleMsgs[index].redpacketMsgs.forEach(
          function (item) {
            if (item.couponInstId == instId) {
              _this.redpacketAmounts[index] = item.couponAmount; //改变后红包金额
            }
          }
        );
        this.redpackagePopup = false;
      }
      let tempcoupon = this.couponAmounts[index]; //优惠券金额
      let tempredpacket = this.redpacketAmounts[index]; //优惠券金额
      if (_this.couponAmounts[index].couponCate == 3) {
        //当前店铺总金额 = bk当前店铺商品总金额 * 折扣  - 红包金额
        _this.OrderSettleMsg.storeOrderSettleMsgs[index].finalPrice = (
          (Number(
            _this.OrderSettleMsg.storeOrderSettleMsgs[index].totalGoodsPrice
          ) *
            _this.couponAmounts[index].couponDiscount) /
            100 -
          Number(tempredpacket)
        ).toFixed(2);
      } else {
        //当前店铺总金额 = 当前店铺商品总金额 - 优惠券金额 - 红包金额
        _this.OrderSettleMsg.storeOrderSettleMsgs[index].finalPrice = (
          Number(
            _this.OrderSettleMsg.storeOrderSettleMsgs[index].totalGoodsPrice
          ) -
          Number(tempcoupon) -
          Number(tempredpacket)
        ).toFixed(2);
      }
      let finalPrice = 0;
      let discountPrice = 0;
      this.OrderSettleMsg.storeOrderSettleMsgs.forEach(function (item) {
        finalPrice += Number(item.finalPrice);
        discountPrice += Number(item.totalGoodsPrice - item.finalPrice);
      });
      this.OrderSettleMsg.finalPrice = finalPrice.toFixed(2);
      this.OrderSettleMsg.discountPrice = discountPrice.toFixed(2);
    },

    // 获取地址列表
    getListAddress() {
      this.listAddress().then((res) => {
        this.addressInfo = res;
        let _this = this;
        if (this.$route.query.selectAddressId) {
          let addressId = _this.$route.query.selectAddressId;
          _this.addressInfo.forEach(function (item, index) {
            if (item.addressId == addressId) _this.selectAddressIndex = index;
          });
        } else {
          //获取默认地址  并默认选中
          _this.addressInfo.forEach(function (item, index) {
            if (item.isDefault == "1") _this.selectAddressIndex = index;
          });
        }
      });
    },

    openinvoice() {
      //选择地址  存储当前订单所有信息
      storage.local.set("orderData", this.orderData);
      this.$router.push({
        path: "/main/writeinvoice",
      });
    },
    openaddr() {
      //选择地址  存储当前订单所有信息
      storage.local.set("orderData", this.orderData);
      if (this.$route.query.orderId == undefined) {
        this.$router.push({
          path:
            "/main/selectaddress?selectAddressId=" +
            this.addressInfo[this.selectAddressIndex].addressId,
        });
      } else {
        this.$router.push({
          path:
            "/main/selectaddress?orderId=" +
            this.$route.query.orderId +
            "&selectAddressId=" +
            this.addressInfo[this.selectAddressIndex].addressId,
        });
      }
      // this.$router.push({
      //   path: '/main/selectaddress?selectAddressId=' + this.addressInfo[this.selectAddressIndex].addressId
      // })
    },
    //新增地址
    addaddr() {
      this.$router.push({
        path: "/main/writeaddress",
      });
    },
    submitOrder_bk() {
      let url = "/main/firmorder";

      // 检查数据
      if (this.selectAddressIndex == null) {
        this.showTipMessage(true, "请选择地址！");
        return;
      }
      //this.load = true;
      let addressId = this.addressInfo[this.selectAddressIndex].addressId;

      //alert("当前页面URL: " + location.href);

      //微信内置浏览器
      if (this.util.isWeiXin()) {
        let url = "/main/firmorder";
        // 1.微信配置
        this.getWxJsSdkConfig([url])
          .then((wxTarget) => {
            //wx.config(wxTarget);
          })
          .then(() => {
            // 2.创建订单
            return this.createOrder([
              1,
              addressId,
              this.settleDatas,
              this.invoiceData,
            ]);
          })
          .then((res) => {
            this.createOrderData = res;
            //alert(" 生成订单结果（订单号）: " + this.createOrderData.orderId);
            //3. 发起微信请求
            return this.callOldWxPay(this.createOrderData.orderId);
            //return this.callNewWxPay();
          })
          .catch((err) => {
            this.showTipMessage(true, err);
          });
      } else {
        this.createOrder([
          1,
          addressId,
          this.settleDatas,
          this.invoiceData,
        ]).then((res) => {
          this.createOrderData = res;
          //3. 发起H5微信请求
          this.callH5WxPay(this.createOrderData.orderId);
        });
      }
    },

    onCreatOrder() {
      // 检查数据
      if (this.selectAddressIndex == null) {
        this.showTipMessage(true, "请选择地址！");
        return;
      }
      //this.load = true;
      let addressId = this.addressInfo[this.selectAddressIndex].addressId;

      this.createOrder([1, addressId, this.settleDatas, this.invoiceData])
        .then((res) => {
          this.createOrderData = res;
          location.href =
            "/main/firmpay?orderId=" + this.createOrderData.orderId;
        })
        .catch((err) => {
          this.showTipMessage(true, JSON.stringify(err));
        });
    },

    submitOrder() {
      // 检查数据
      if (this.selectAddressIndex == null) {
        this.showTipMessage(true, "请选择地址！");
        return;
      }
      //this.load = true;
      let addressId = this.addressInfo[this.selectAddressIndex].addressId;

      //微信内置浏览器
      if (this.util.isWeiXin()) {
        if (
          this.createOrderData.orderId == null &&
          this.$route.query.orderId == null
        ) {
          //判断当前url是否有orderId或订单已生成
          this.pay.loading = true;
          this.pay.message = "订单提交中···";
          return this.createOrder([
            1,
            addressId,
            this.settleDatas,
            this.invoiceData,
          ])
            .then((res) => {
              this.pay.loading = true;
              this.pay.message = "等待支付···";
              this.createOrderData = res;
              return this.callOldWxPay(this.createOrderData.orderId);
              //return this.callNewWxPay();
            })
            .catch((err) => {
              this.showTipMessage(true, JSON.stringify(err));
            });
        } else {
          let orderId =
            this.createOrderData.orderId || this.$route.query.orderId;
          this.pay.loading = true;
          this.pay.message = "订单提交中···";
          return this.createOrderWithOrder([
            orderId,
            1,
            addressId,
            this.settleDatas,
            this.invoiceData,
          ])
            .then((res) => {
              this.pay.loading = true;
              this.pay.message = "等待支付···";
              return this.callOldWxPay(orderId);
              //return this.callNewWxPay();
            })
            .catch((err) => {
              this.showTipMessage(true, JSON.stringify(err));
            });
        }
      } else {
        if (
          this.createOrderData.orderId == null &&
          this.$route.query.orderId == null
        ) {
          //判断当前url是否有orderId或订单已生成
          this.pay.loading = true;
          this.pay.message = "订单提交中···";
          return this.createOrder([
            1,
            addressId,
            this.settleDatas,
            this.invoiceData,
          ])
            .then((res) => {
              this.createOrderData = res;
              this.pay.loading = true;
              this.pay.message = "等待支付···";
              //3. 发起H5微信请求
              return this.callH5WxPay(this.createOrderData.orderId);
            })
            .catch((err) => {
              this.showTipMessage(true, JSON.stringify(err));
            });
        } else {
          let orderId =
            this.createOrderData.orderId || this.$route.query.orderId;
          this.pay.loading = true;
          this.pay.message = "订单提交中···";
          return this.createOrderWithOrder([
            orderId,
            1,
            addressId,
            this.settleDatas,
            this.invoiceData,
          ])
            .then((res) => {
              this.pay.loading = true;
              this.pay.message = "等待支付···";
              return this.callH5WxPay(orderId);
              //return this.callNewWxPay();
            })
            .catch((err) => {
              this.showTipMessage(true, JSON.stringify(err));
            });
        }
      }
    },

    //银联支付
    submitUnionOrder() {
      if (this.selectAddressIndex == null) {
        this.showTipMessage(true, "请选择地址！");
        return;
      }
      let addressId = this.addressInfo[this.selectAddressIndex].addressId;
      //创建订单
      if (
        this.createOrderData.orderId == null &&
        this.$route.query.orderId == null
      ) {
        //判断当前url是否有orderId或订单已生成
        this.creatCartOrder(addressId);
      } else {
        let orderId = this.createOrderData.orderId || this.$route.query.orderId;
        this.pay.loading = true;
        this.pay.message = "订单提交中···";
        return this.createOrderWithOrder([
          orderId,
          1,
          addressId,
          this.settleDatas,
          this.invoiceData,
        ])
          .then((res) => {
            this.pay.loading = true;
            this.pay.message = "等待支付···";
            this.callUnionPay(
              this.createOrderData.orderId || this.$route.query.orderId
            );
          })
          .catch((err) => {
            this.showTipMessage(true, JSON.stringify(err));
          });
      }
    },
    //创建订单
    creatCartOrder(addressId) {
      // 检查数据

      this.pay.loading = true;
      this.pay.message = "订单提交中···";
      this.createOrder([1, addressId, this.settleDatas, this.invoiceData])
        .then((res) => {
          this.createOrderData = res;
          this.pay.loading = true;
          this.pay.message = "等待支付···";
          this.callUnionPay(this.createOrderData.orderId);
        })
        .catch((err) => {
          this.showTipMessage(true, JSON.stringify(err));
        });
    },
    // 银联wap网关支付
    callUnionPay(orderNo) {
      this.doUnionWapConsumePay([orderNo])
        .then((res) => {
          let boxId = "_mxmall_unionpay_box_";
          const div = document.createElement("div");
          div.id = boxId;
          div.innerHTML = res;
          document.body.appendChild(div);
          document.querySelector("#" + boxId + " > form").submit();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    //微信H5支付
    callH5WxPay(orderId) {
      let _this = this;
      this.doWxH5Pay([
        orderId || _this.createOrderData.orderId || _this.$route.query.orderId,
      ])
        .then((res) => {
          if (res.success && res.errCode == "ORDERPAID") {
            _this.showTipMessage(true, "该订单已支付成功");
            location.href =
              "/main/paysuccess?orderId=" + orderId ||
              _this.createOrderData.orderId ||
              _this.$route.query.orderId;
            return;
          }
          let url = res.target.target;
          //重定向
          location.replace(url);
          //TODO
        })
        .catch((err) => {
          //alert(err)
        });
    },
    //旧版微信支付
    callOldWxPay(orderId) {
      let _this = this;

      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
        }
      } else {
        return this.doWxMpPay([orderId || this.createOrderData.orderId])
          .then((resWxPay) => {
            //alert("调用服务端doWxMpPay,返回结果resWxPay："+JSON.stringify(resWxPay));
            if (
              !resWxPay ||
              !resWxPay.success ||
              !resWxPay.target ||
              !resWxPay.target.success
            ) {
              _this.showTipMessage(
                true,
                (resWxPay && resWxPay.message) ||
                  (resWxPay && resWxPay.target && resWxPay.target.message) ||
                  "抱歉，支付失败！"
              );
              //防止重复提交
              location.href = "/main/myorders";
              return;
            }

            WeixinJSBridge.invoke(
              "getBrandWCPayRequest",
              {
                appId: resWxPay.target.target.appId, //公众号名称，由商户传入
                timeStamp: resWxPay.target.target.timeStamp, //时间戳，自1970年以来的秒数
                nonceStr: resWxPay.target.target.nonceStr, //随机串
                package: resWxPay.target.target.package,
                signType: resWxPay.target.target.signType, //微信签名方式：
                paySign: resWxPay.target.target.paySign, //微信签名
              },
              function (res) {
                //alert("STEP 4 微信服务器返回结果: " + JSON.stringify(res));
                // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回   ok，但并不保证它绝对可靠。
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  _this.showTipMessage(true, "支付成功");
                  location.href =
                    "/main/paysuccess?orderId=" +
                      _this.createOrderData.orderId ||
                    _this.$route.query.orderId;
                } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                  _this.showTipMessage(true, "支付失败");
                  location.href = "/main/myorders?type=2";
                } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                  _this.showTipMessage(true, "已取消支付");
                  location.href = "/main/myorders?type=2";
                }
              }
            );
          })
          .catch((err) => {
            _this.showTipMessage(true, err || "支付失败!");
            location.href = "/main/myorders?type=2";
          });
      }
    },

    //新版微信支付
    callNewWxPay() {
      let _this = this;
      this.doWxMpPay([this.createOrderData.orderId]).then((resWxPay) => {
        //alert("STEP 3 微信公众号支付  doWxMpPay  --: " +  JSON.stringify(resWxPay));

        if (resWxPay.success == true && resWxPay.errCode == "ORDERPAID") {
          //已经支付成功   ->   支付成功页面
          location.href = "/main/myorders";
        }

        wx.chooseWXPay({
          timestamp: resWxPay.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写
          nonceStr: resWxPay.nonceStr, // 支付签名随机串，不长于 32 位
          package: resWxPay.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
          signType: resWxPay.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: resWxPay.paySign, // 支付签名
          success: function (res) {
            //alert(" 微信支付: " + res);
            if (res.errMsg == "chooseWXPay:ok") {
              _this.showTipMessage(true, "支付成功");
            }
          },
          cancel: function (res) {
            //alert("STEP 4 您取消了支付！");
            _this.showTipMessage(true, "已取消支付");
          },
          fail: function (err) {
            //alert("FAIL:" + JSON.stringify(err));
            _this.showTipMessage(true, JSON.stringify(err));
          },
        });
      });
    },

    finishPay() {
      this.isShowFirmBox = false;

      //H5重定向回来的ORDERID
      let orderId = this.createOrderData.orderId || this.$route.query.orderId;
      if (!orderId) {
        this.showTipMessage(true, "订单不存在");
        return;
      }

      location.href = "/main/paysuccess?orderId=" + orderId;
    },

    onScroll() {
      this.scrolled = document.querySelectorAll(
        ".firmorderWrapper"
      )[0].scrollTop;
    },
  },
  components: {
    menus,
    touchDelete,
    myOrdersItem,
    imgs,
  },
  mounted() {
    this.$nextTick(function () {
      document
        .querySelectorAll(".firmorderWrapper")[0]
        .addEventListener("scroll", this.onScroll);
    });
  },
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import "src/common/sass/mixin.scss";
@import "src/views/personal/personal.scss";
.firmorder-wrap {
  .order-box {
    @include font-dpr(14px);
    background: #fff;
    /*margin-bottom: 0.2rem;*/
    @include bdT(#d7d7d7, bottom);
    line-height: 1rem;
    .textright {
      text-align: right;
      font-weight: 600;
    }
    /*品牌标题*/
    .brandTitle {
      padding: 0 0.4rem;
      height: 1rem;
      line-height: 1rem;
      background: #fff;
      @include bdT(#e5e5e5, bottom);
      input {
        width: 3rem;
        float: right;
        margin: 0.15rem 0 0 0;
        height: 0.7rem;
        line-height: 0.7rem;
        background: #f5f5f5;
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        padding-left: 0.1rem;
        @include font-dpr(12px);
      }
      .list-radio {
        min-width: 0.5rem;
        height: 0.5rem;
        margin-top: 0.25rem;
        margin-right: 0.4rem;
      }
      .logo {
        margin-right: 0.2rem;
        width: auto;
        img {
          height: auto;
          width: 100%;
          max-height: 1rem;
          max-width: 1.5rem;
        }
      }
      p {
        float: left;
        margin-right: 0.2rem;
        color: #2a2a2a;
        label {
          color: #999999;
        }
      }
      .user-right {
        height: 0.3rem;
      }
    }
    .order-box-item {
      color: #666;
      margin: 0 0.35rem;
      @include bdT(#d7d7d7, bottom);

      label.black {
        color: #000;
      }
      label.not-available {
        color: #999;
      }
    }
    .order-box-item:last-child {
      @include bdT(rgba(255, 255, 255, 0), bottom);
    }
    input.order-box-item {
      width: 90%;
    }
    .user-right {
      margin-left: 0.3rem;
      height: 0.3rem;
    }
    .goods-title {
      margin: 0 0.35rem;
      @include font-dpr(12px);
      color: #000000;
    }
  }
  .order-box.mgb {
    margin-bottom: 0.2rem;
    @include bdT(rgba(230, 0, 18, 0), bottom);
  }
  .order-box.addr {
    @include bdT(rgba(230, 0, 18, 0), bottom);
    margin-top: 0.125rem;
    background: #fffaf4;
    .border-img {
      height: 2px;
      width: 100%;
      background: url(/static/images/addr_dottedLine@3x.png);
      background-size: 1.5rem 2px;
    }
    .addr-info {
      line-height: 1.8;
      margin: 0.2rem 0.4rem;
      padding-right: 0.6rem;
      background: url(/static/images/ic_more_3x.png) no-repeat center right;
      background-size: auto 0.4rem;
      .addr-title {
        color: #979797;
      }
    }
    .none-addr-info {
      text-align: center;
      margin-top: 0.2rem;
      margin-bottom: 0.4rem;
      .demo-raised-button {
        @include font-dpr(14px);
        background: #eb7c06;
        border-radius: 4px;
        color: #fff;
        height: 0.9rem;
        line-height: 0.9rem;
      }
    }
  }
  .delivery-addr {
    line-height: 0.75rem;
    padding: 0 0.35rem;
    width: 100%;
    background: #ffe3e6;
  }
  .fixed {
    position: fixed;
    bottom: 1.15rem;
    z-index: 9;
    width: 100%;
  }

  /*列表*/
  .mu-list {
    padding: 0;
    margin-top: 0.35rem;
    .point {
      &:after {
        height: 2rem;
      }
    }
    .diy-list .mu-item {
      padding: 0 0.4rem 0.4rem 2.9rem;
    }
    .mu-item {
      background: #fff;
      height: 2.3rem;
      padding: 0 0.4rem 0.4rem 2.5rem;
      .mu-item-left,
      .mu-item-right {
        width: 1.9rem;
        max-height: 2.5rem;
        left: 0.4rem;
        height: initial;
        top: initial;
      }
    }
    .mu-item-content {
      align-self: unset;
      .mu-item-title-row {
        .mu-item-title {
          @include font-dpr(14px);
          line-height: 1.5;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      /*列表价格  加减*/
      .listItem {
        line-height: 1;
        margin-top: 0.2rem;
        text-align: center;
        .price {
          float: left;
          @include font-dpr(16px);
          color: #e60012;
          position: absolute;
          bottom: 0.4rem;
          label {
            @include font-dpr(13px);
          }
        }
        .count {
          margin-top: 0.1rem;
          @include font-dpr(12px);
          color: #999999;
          margin-left: 0.2rem;
        }
      }
    }
  }
}
.mu-dialog {
  .payTitle {
    padding: 0.3rem 0;
    @include font-dpr(14px);
    border-bottom: 1px solid #ccc;
  }
  .payBody {
    @include font-dpr(16px);
    padding: 0.3rem 0 !important;
    border-bottom: 1px solid #ccc;
  }
  .payActionsContainer {
    @include font-dpr(14px);
    color: #999999;
    text-align: center;
    display: block;
    padding: 0.3rem;
  }
}
.coupon-popup-bottom {
  width: 100%;
  height: 9.25rem;
  background: #fff;
  font-size: 0;
  .flex-item {
    padding: 0.2rem 0.35rem;
    .goods-detail {
      position: relative;
      padding-bottom: 0.2rem;
      .close-button {
        display: inline-block;
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        top: 0;
        right: 0;
        background: url(/static/images/dialog_cancel_3x.png) no-repeat center;
        background-size: cover;
        z-index: 5;
      }
      .coupon-box {
        .coupon-list {
          .coupon-list-item.title {
            text-align: center;
            @include font-dpr(18px);
            color: #333333;
            @include bdT(rgba(255, 255, 255, 0), bottom);
          }
          .coupon-list-item {
            width: 100%;
            @include font-dpr(14px);
            color: #333333;
            padding: 0.35rem 0;
            @include bdT(#e5e5e5, bottom);
            .list-radio {
              height: 0.5rem;
              min-width: 0.85rem;
            }
          }
        }
      }
    }
  }
  .mu-raised-button {
    display: inline-block;
    width: 50%;
    border: 0px solid;
    box-shadow: none;
    border-radius: 0;
    vertical-align: top;
    min-width: auto;
    height: 1.25rem;
    color: #fff;
    @include font-dpr(16px);
    &.add-cart {
      background: #ff910e;
    }
    &.buyNow {
      background: #e60012;
    }
    &.fullButton {
      width: 100%;
      background-image: linear-gradient(-90deg, #ff4901 0%, #ff7701 100%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// firmorder.vue?e4674e36